import { cn } from '../lib/cn.js';
import { AiMark } from '../brand/BrandMark.js';

export type AiLabelVariant = 'insight' | 'suggestion' | 'detection' | 'summary';

const VARIANT_TAG: Record<AiLabelVariant, string> = {
  insight: 'Insight',
  suggestion: 'Sugerencia',
  detection: 'Detección',
  summary: 'Resumen',
};

export interface AiLabelProps {
  variant?: AiLabelVariant;
  /** Overrides the default tag, e.g. a confidence readout. */
  tag?: string;
  className?: string;
}

/**
 * Attribution line for anything KainOS AI produced.
 *
 * Every AI-authored surface carries this label — users should always be able to
 * tell at a glance what came from a model and what came from a person.
 */
export function AiLabel({ variant = 'insight', tag, className }: AiLabelProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 whitespace-nowrap text-[12px] font-semibold leading-none',
        className,
      )}
    >
      <AiMark size={20} />
      <span className="text-brand">KainOS AI</span>
      <span className="h-[3px] w-[3px] rounded-full bg-ink-faint" aria-hidden="true" />
      <span className="font-medium text-ink-muted">{tag ?? VARIANT_TAG[variant]}</span>
    </span>
  );
}
